module.exports = __webpack_public_path__ + "static/media/img-block-3.c39a0b65.png";